
class SnsShare
{
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.elClass = '.c-btn-share'
    this.hashTag = '#hoppyhappy'
    this.meta = {}
    this.init();
  }

  /**
   * 初期化
   */
  init() {
    const elAll = document.querySelectorAll(this.elClass)

    if (!elAll) return

    this.meta = this.getMeta()
    const elAllArr = Array.prototype.slice.call(elAll); //Array
    elAllArr.forEach((el, index) => {
      /** twitter */
      el.querySelector('.c-btn-tw').setAttribute('href', 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(`${this.meta.title} ${this.meta.url} ${this.meta.hashtag}`))
      el.querySelector('.c-btn-tw').setAttribute('target', '_blank')

      /** facebook */
      el.querySelector('.c-btn-fb').setAttribute('href', 'http://www.facebook.com/share.php?u=' + this.meta.url)
      el.querySelector('.c-btn-fb').setAttribute('target', '_blank')

      /** line */
      el.querySelector('.c-btn-line').setAttribute('href', "http://line.me/R/msg/text/?" + encodeURIComponent(`${this.meta.title} ${this.meta.url} ${this.meta.hashtag}`) +'%0D%0A'+ this.meta.url)
      el.querySelector('.c-btn-line').setAttribute('target', '_blank')
    })
  }

  /**
   * ページに設定されているメタタグを取得する
   */
  getMeta() {
    const ogTitle = document.querySelector("meta[property='og:title']")
    const ogDescription = document.querySelector("meta[property='og:description']")
    const ogUrl = document.querySelector("meta[property='og:url']")

    return {
      title: ogTitle ? ogTitle.getAttribute('content') : '',
      description: ogDescription ? ogDescription.getAttribute('content') : '',
      url: ogUrl ? ogUrl.getAttribute('content') : location.href,
      hashtag: this.hashTag
    }
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default SnsShare